import './App.css'
import ProtectedRoute from './components/AuthGuard';
import Toast from './components/Toast';
import MainLayout from './layout/MainLayout';

import { Route, Routes } from 'react-router-dom';
import SignIn from './pages/SignIn';
import DashboardMain from './pages/Dashboards/DashboardMain';
import Clients from './pages/Clients';
import AgentsTable from './pages/Agent/AgentTable';
import AssetsTable from './pages/Assets/AssetsTable';
import Cameras from './pages/cameras/Cameras';
import TopologyBuilder from './pages/AssetTopology/TopologyBuilder';
import DBTopologyFlow from './pages/topology/DBTopologyFlow';
import InternalAssetResultsTable from './pages/InternalScan/Internal_scan_result';
import AssetDashboardLayout from './pages/InternalScan/InternalScanDashboard/AssetDashboardLayout';
import Users from './pages/User';
import Roles from './pages/Roles';
import SettingsMain from './pages/Settings/SettingsMain';
import ReportsDashboard from './pages/Reports/ReportsDashboard';
import ReportViewer from './pages/Reports/ReportViewer';
import CustomReportBuilder from './pages/Reports/CustomReportBuilder';
import EventsTable from './pages/Events/EventsTable';
import CredentialConfigPage from './pages/Agent/AgentCredsConfig/CredentialConfigPage';
import AgentSSH from './pages/Agent/AgentSSH';
import { AuditLogs } from './pages/AuditLogs';
import ActiveDirectoryMain from './pages/ActiveDirectory/ActiveDirectoryMain';
import ActiveDirectoryMainV2 from './pages/ActiveDirectoryv2/ActiveDirectoryMainV2';
// import PatchManagement from './pages/PatchManagement';
import PatchMain from './pages/PatchManagement/PatchMain';
import PatchJobsMain from './pages/PatchManagement/PatchJobsMain';
import SOPPage from './pages/SOP/SOPPage';
import DocumentationPage from './pages/Documentation/DocumentationPage';
import SceneMain from './pages/DigitalTwin/SceneMain';
import DigitalTwinDashboardMain from './pages/DigitalTwin/DigitalTwinDashboard/DigitalTwinDashboardMain';
import ClientSiteMap from './pages/DigitalTwin/ClientSiteMap';
import AnalyticsDashboardTable from './pages/CustomDashboard/AnalyticsDashboardTable';
import DashboardBuilderPage from './pages/CustomDashboard/DashboardBuilderPage';
import AddWidgetPage from './pages/CustomDashboard/AddWidgetPage';
import VisualizePage from './pages/CustomDashboard/VisualizePage';
import KubernetesTable from './pages/Kubernetes/KubernetesTable';
import KubernetesTab from './pages/Kubernetes/KubernetesTab';
import ExternalScanTable from './pages/ExternalScan/ExternalScanTable';
import ExternalScanJobs from './pages/ExternalScan/ExternalScanJobs';
import ExternalScanResults from './pages/ExternalScan/ExternalScanResults';
import CustomDashboardV2 from './pages/CustomDashboardV2/CustomDashboardV2';
import Jobs from './pages/Settings/Scheduler/Jobs';
import DBMonitorDashboard from './pages/DBMonitor/DBMonitorDashboard';
import AutomationEditor from './pages/Automation/AutomationEditor';
import AutomationMain from './pages/Automation/AutomationMain';
import HtmlTemplateEditor from './pages/Automation/HtmlTemplateEditor';
import ReportsListTable from './pages/CustomReports/ReportsListTable';
import CustomReportsMain from './pages/CustomReports/CustomReportsMain';
import ReportPrintViewer from './pages/CustomReports/ReportPrintViewer';


function App() {

  return (
    <>
      <Toast />
      <Routes>
        <Route path="/" element={<SignIn />} />
        <Route path="/documentation" element={<DocumentationPage />} />
        {/* Single Standalone Report View for Backend */}
        <Route path="/customreports/preview/:id" element={<ReportPrintViewer />} />
        <Route element={<ProtectedRoute><MainLayout /></ProtectedRoute>}>
          <Route path="/dashboard" element={<ProtectedRoute><DashboardMain /></ProtectedRoute>} />
          <Route path="/clients" element={<ProtectedRoute><Clients /></ProtectedRoute>} />
          <Route path="/agents" element={<ProtectedRoute><AgentsTable /></ProtectedRoute>} />
          <Route path="/kubernetes" element={<ProtectedRoute><KubernetesTable /></ProtectedRoute>} />
          <Route path="/kubernetes/dashboard/:agentId" element={<ProtectedRoute><KubernetesTab /></ProtectedRoute>} />
          {/* <Route path="/topology" element={<ProtectedRoute><TopologyFlow /></ProtectedRoute>} /> */}
          <Route path="/asset" element={<ProtectedRoute><AssetsTable /></ProtectedRoute>} />
          <Route path="/cameras" element={<ProtectedRoute><Cameras /></ProtectedRoute>} />
          {/* <Route path="/streams" element={<ProtectedRoute><Streams /></ProtectedRoute>} /> */}
          <Route path="/topology" element={<ProtectedRoute><TopologyBuilder /></ProtectedRoute>} />
          <Route path="/db-topology" element={<ProtectedRoute><DBTopologyFlow /></ProtectedRoute>} />
          <Route path="/db-topology/:clusterId" element={<ProtectedRoute><DBTopologyFlow /></ProtectedRoute>} />
          <Route path="/db-monitor" element={<ProtectedRoute><DBMonitorDashboard /></ProtectedRoute>} />
          <Route path="/users" element={<ProtectedRoute><Users /></ProtectedRoute>} />
          <Route path="/roles" element={<ProtectedRoute><Roles /></ProtectedRoute>} />
          <Route path="/internal_scan" element={<ProtectedRoute><InternalAssetResultsTable /></ProtectedRoute>} />
          <Route path='/asset/dashboard' element={<ProtectedRoute><AssetDashboardLayout /></ProtectedRoute>} />
          <Route path='/settings' element={<ProtectedRoute><SettingsMain /></ProtectedRoute>} />
          <Route path='/reports' element={<ProtectedRoute><ReportsDashboard /></ProtectedRoute>} />
          <Route path='/reports/custom-reports' element={<ProtectedRoute><CustomReportBuilder /></ProtectedRoute>} />
          <Route path='/reports/:reportKey' element={<ProtectedRoute><ReportViewer /></ProtectedRoute>} />
          <Route path='/customreports' element={<ProtectedRoute><ReportsListTable /></ProtectedRoute>} />
          <Route path='/customreports/builder' element={<ProtectedRoute><CustomReportsMain /></ProtectedRoute>} />
          <Route path='/customreports/builder/:id' element={<ProtectedRoute><CustomReportsMain /></ProtectedRoute>} />
          <Route path='/events' element={<ProtectedRoute><EventsTable /></ProtectedRoute>} />
          <Route path='/agent-credentials/:agentId' element={<ProtectedRoute><CredentialConfigPage /></ProtectedRoute>} />
          <Route path='/agent-ssh/:agentId' element={<ProtectedRoute><AgentSSH /></ProtectedRoute>} />
          <Route path='/audit-logs' element={<ProtectedRoute><AuditLogs /></ProtectedRoute>} />
          <Route path='asset/active-directory' element={<ProtectedRoute><ActiveDirectoryMain /></ProtectedRoute>} />
          <Route path='asset/active-directory-v2' element={<ProtectedRoute><ActiveDirectoryMainV2 /></ProtectedRoute>} />
          <Route path='/patching' element={<ProtectedRoute><PatchMain /></ProtectedRoute>} />
          <Route path='/patching/jobs' element={<ProtectedRoute><PatchJobsMain /></ProtectedRoute>} />
          <Route path='/sop' element={<ProtectedRoute><SOPPage /></ProtectedRoute>} />
          <Route path='/digital-twin' element={<ProtectedRoute><ClientSiteMap /></ProtectedRoute>} />
          <Route path='/digital-twin/model/:clientId' element={<ProtectedRoute><SceneMain /></ProtectedRoute>} />
          <Route path='/digital-twin/dashboard' element={<ProtectedRoute><DigitalTwinDashboardMain /></ProtectedRoute>} />
          <Route path='/custom-dashboard' element={<ProtectedRoute><AnalyticsDashboardTable /></ProtectedRoute>} />
          <Route path='/custom-dashboard-v2' element={<ProtectedRoute><CustomDashboardV2 /></ProtectedRoute>} />
          <Route path='/custom-dashboard/create' element={<ProtectedRoute><DashboardBuilderPage /></ProtectedRoute>} />
          <Route path='/custom-dashboard/addwidget' element={<ProtectedRoute><AddWidgetPage /></ProtectedRoute>} />
          <Route path='/custom-dashboard/visualize' element={<ProtectedRoute><VisualizePage /></ProtectedRoute>} />
          <Route path='/custom-dashboard/visualize/create' element={<ProtectedRoute><VisualizePage /></ProtectedRoute>} />
          <Route path='/external-scan' element={<ProtectedRoute><ExternalScanTable /></ProtectedRoute>} />
          <Route path='/external-scan/jobs' element={<ProtectedRoute><ExternalScanJobs /></ProtectedRoute>} />
          <Route path='/jobs' element={<ProtectedRoute><Jobs /></ProtectedRoute>} />
          <Route path='/external-scan/results/:assetId' element={<ProtectedRoute><ExternalScanResults /></ProtectedRoute>} />


          <Route path='/automation' element={<ProtectedRoute><AutomationMain /></ProtectedRoute>} />
          <Route path='/automation/editor' element={<ProtectedRoute><AutomationEditor /></ProtectedRoute>} />
          <Route path='/automation/editor/:id' element={<ProtectedRoute><AutomationEditor /></ProtectedRoute>} />
          <Route path='/automation/templates/editor' element={<ProtectedRoute><HtmlTemplateEditor /></ProtectedRoute>} />
          <Route path='/automation/templates/editor/:id' element={<ProtectedRoute><HtmlTemplateEditor /></ProtectedRoute>} />


        </Route>

      </Routes>
    </>
  )
}

export default App
